
import { defineComponent, SetupContext, onBeforeUnmount, ref } from "vue";
import { draggable } from "@/utils/draggable";
import { _$t } from "@/utils/i18n";
import { processend } from "@/utils/view";

type Props = {
  safe: boolean;
  okButtonHide: boolean;
  secondaryButton: boolean;
  cancelButton: boolean;
  message: string;
  okName: string;
  secondaryName: string;
  cancelName: string;
  okClass: string;
  id: string;
};

export default defineComponent({
  name: "Message",
  directives: {
    drag: draggable,
  },
  props: {
    safe: {
      type: Boolean,
      default: false,
    },
    okButtonHide: {
      type: Boolean,
      default: false,
    },
    secondaryButton: {
      type: Boolean,
      default: false,
    },
    cancelButton: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
    okName: {
      type: String,
      default: "OK",
    },
    secondaryName: {
      type: String,
      default: "Secondary",
    },
    cancelName: {
      type: String,
      default: () => _$t("msg_common_cancel"),
    },
    okClass: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
  },
  setup(props: Props, context: SetupContext) {
    const main = ref<HTMLDivElement>();

    const ok = (e: Event): void => {
      e.stopImmediatePropagation();
      context.emit("ok", e);
    };

    const secondary = (e: Event): void => {
      e.stopImmediatePropagation();
      context.emit("secondary", e);
    };

    const cancel = (e: Event): void => {
      e.stopImmediatePropagation();
      context.emit("cancel", e);
    };

    onBeforeUnmount(() => {
      // コンポーネントを破棄する前に、モーダルバック画面削除
      // モーダル表示中にブラウザバックするとモーダルバック画面が消えない為
      processend();
    });

    // エラーメッセージが"undefined"の場合はメッセージを上書きする。
    if (props.message === undefined || props.message === "undefined") {
      // eslint-disable-next-line vue/no-mutating-props
      props.message = _$t("msg_common_uncaughtException");
    }

    return {
      main,
      props,
      ok,
      secondary,
      cancel,
    };
  },
});
